"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _recipient = require("./recipient/recipient.epic");

var _campaigns = require("./campaigns/campaigns.epic");

var _templates = require("./templates/templates.epic");

var _gift = require("./gift/gift.epic");

var _contacts = require("./contacts/contacts.epic");

var _sendAs = require("./send-as/send-as.epic");

var _marketplace = require("./marketplace/marketplace.epic");

var _contactEnrichment = require("./contactEnrichment/contactEnrichment.epic");

var _postcard = require("./gift/postcard");

var _invitationType = require("./gift/invitationType/invitationType.epic");

var _customData = require("./customData/customData.epic");

var _address = require("./address");

var _shipping = require("./shipping");

var _product = require("./product/product.epics");

var createGiftEpics = [].concat((0, _toConsumableArray2.default)(_recipient.recipientEpics), (0, _toConsumableArray2.default)(_campaigns.campaignsEpics), (0, _toConsumableArray2.default)(_gift.giftEpics), (0, _toConsumableArray2.default)(_templates.templatesEpics), (0, _toConsumableArray2.default)(_contacts.contactsEpics), (0, _toConsumableArray2.default)(_sendAs.sendAsEpics), (0, _toConsumableArray2.default)(_marketplace.marketplaceEpics), (0, _toConsumableArray2.default)(_contactEnrichment.contactEnrichmentEpic), (0, _toConsumableArray2.default)(_postcard.postcardEpics), (0, _toConsumableArray2.default)(_invitationType.invitationTypeEpics), (0, _toConsumableArray2.default)(_customData.customDataEpics), (0, _toConsumableArray2.default)(_address.addressEpics), (0, _toConsumableArray2.default)(_shipping.shippingEpics), (0, _toConsumableArray2.default)(_product.productEpics));
var _default = createGiftEpics;
exports.default = _default;